<template>
<div>
  <details>
    <summary><em>Your Sample Requests</em></summary>

    <!--Collapsible table for pending sample_requests-->
    <details>
      <summary>Pending Sample Requests</summary>
      <table class="table table-hover">
      <thead class="blue-gradient white-text">
      <tr>
            <th colspan="2">PENDING</th>
      </tr>
      <tr>
        <th scope="col"><em><b>ID</b></em></th>
        <th scope="col"><em><b>PROJECT</b></em></th>
        <th scope="col"><em><b>PROJECT OWNER</b></em></th>
        <th scope="col"><em><b>SAMPLE SPECIES</b></em></th>
        <th scope="col"><em><b>SAMPLE TYPE</b></em></th>
        <th scope="col"><em><b>REQUESTED AMOUNT</b></em></th>
        <th scope="col"><em><b>REQUEST DATE</b></em></th>
        <th scope="col"><em><b>RESPONSE DATE</b></em></th>
        <th scope="col"><em><b>ACTIONS</b></em></th>
      </tr>
      </thead>
      <tbody>
      <tr :key="request.id" v-for="(request, index) in response.pending_sample_requests">
        <td> {{ index + 1 }}</td>
        <td v-if="request.project"> {{ request.project }}</td>
        <td v-else> N/A</td>
        <td v-if="request.owner"> {{ request.owner }}</td>
        <td v-else> N/A</td>
        <td v-if="request.species"> {{ request.species }}</td>
        <td v-else> N/A</td>
        <td v-if="request.type"> {{ request.type }}</td>
        <td v-else> N/A</td>
        <td v-if="request.amount"> {{ request.amount }}</td>
        <td v-else> N/A</td>
        <td v-if="request.request_date"> {{ request.request_date }}</td>
        <td v-else> N/A</td>
        <td v-if="request.response_date"> {{ request.response_date }}</td>
        <td v-else> N/A</td>
        &nbsp;
        <b-icon
            @click="viewMyRequest(request)"
            class="border border-info rounded"
            :font-scale="`${font_scale}`" icon="eye-fill"
            title="View"
            v-b-modal.modal-sample-request
            v-b-tooltip.hover variant="info"
        ></b-icon>
        &nbsp;
        <b-icon
            @click="showModal = !showModal"
            @mouseover="fillFormForUpdate(request)"
            class="border border-info rounded"
            :font-scale="`${font_scale}`"
            icon="pencil" title="Update"
            v-b-modal.modal-sample-request-edit v-b-tooltip.hover
            v-if="request.status === 'PENDING'"
            variant="info"
        ></b-icon>
        &nbsp;
        <b-icon
            @click="deleteSampleRequest(request.code)"
            class="border rounded bg-danger p-1"
            :font-scale="`${font_scale}`" icon="trash"
            title="Delete" v-b-tooltip.hover
            variant="light"
        ></b-icon>
      </tr>
      </tbody>
    </table>
    </details>

    <!--Collapsible table for approved sample_requests-->
    <details>
      <summary>Approved Sample Requests</summary>
      <table class="table table-hover">
      <thead class="blue-gradient white-text">
      <tr>
            <th colspan="2">APPROVED</th>
      </tr>
      <tr>
        <th scope="col"><em><b>ID</b></em></th>
        <th scope="col"><em><b>PROJECT</b></em></th>
        <th scope="col"><em><b>PROJECT OWNER</b></em></th>
        <th scope="col"><em><b>SAMPLE SPECIES</b></em></th>
        <th scope="col"><em><b>SAMPLE TYPE</b></em></th>
        <th scope="col"><em><b>REQUESTED AMOUNT</b></em></th>
        <th scope="col"><em><b>REQUEST DATE</b></em></th>
        <th scope="col"><em><b>RESPONSE DATE</b></em></th>
        <th scope="col"><em><b>ACTIONS</b></em></th>
      </tr>
      </thead>
      <tbody>
      <tr :key="request.id" v-for="(request, index) in response.approved_sample_requests">
        <td> {{ index + 1 }}</td>
        <td v-if="request.project"> {{ request.project }}</td>
        <td v-else> N/A</td>
        <td v-if="request.owner"> {{ request.owner }}</td>
        <td v-else> N/A</td>
        <td v-if="request.species"> {{ request.species }}</td>
        <td v-else> N/A</td>
        <td v-if="request.type"> {{ request.type }}</td>
        <td v-else> N/A</td>
        <td v-if="request.amount"> {{ request.amount }}</td>
        <td v-else> N/A</td>
        <td v-if="request.request_date"> {{ request.request_date }}</td>
        <td v-else> N/A</td>
        <td v-if="request.response_date"> {{ request.response_date }}</td>
        <td v-else> N/A</td>
        &nbsp;
        <b-icon
            @click="viewMyRequest(request)"
            class="border border-info rounded"
            :font-scale="`${font_scale}`" icon="eye-fill"
            title="View"
            v-b-modal.modal-sample-request
            v-b-tooltip.hover variant="info"
        ></b-icon>
        &nbsp;
        <b-icon
            @click="showModal = !showModal"
            @mouseover="fillFormForUpdate(request)"
            class="border border-info rounded"
            :font-scale="`${font_scale}`"
            icon="pencil" title="Update"
            v-b-modal.modal-sample-request-edit v-b-tooltip.hover
            v-if="request.status === 'PENDING'"
            variant="info"
        ></b-icon>
        &nbsp;
        <b-icon
            @click="deleteSampleRequest(request.code)"
            class="border rounded bg-danger p-1"
            :font-scale="`${font_scale}`" icon="trash"
            title="Delete" v-b-tooltip.hover
            variant="light"
        ></b-icon>
      </tr>
      </tbody>
    </table>
    </details>

     <!--Collapsible table for declined sample_requests-->
    <details>
      <summary>Declined Sample Requests</summary>
      <table class="table table-hover">
      <thead class="blue-gradient white-text">
      <tr>
            <th colspan="2">DECLINED</th>
      </tr>
      <tr>
        <th scope="col"><em><b>ID</b></em></th>
        <th scope="col"><em><b>PROJECT</b></em></th>
        <th scope="col"><em><b>PROJECT OWNER</b></em></th>
        <th scope="col"><em><b>SAMPLE SPECIES</b></em></th>
        <th scope="col"><em><b>SAMPLE TYPE</b></em></th>
        <th scope="col"><em><b>REQUESTED AMOUNT</b></em></th>
        <th scope="col"><em><b>REQUEST DATE</b></em></th>
        <th scope="col"><em><b>RESPONSE DATE</b></em></th>
        <th scope="col"><em><b>ACTIONS</b></em></th>
      </tr>
      </thead>
      <tbody>
      <tr :key="request.id" v-for="(request, index) in response.declined_sample_requests">
        <td> {{ index + 1 }}</td>
        <td v-if="request.project"> {{ request.project }}</td>
        <td v-else> N/A</td>
        <td v-if="request.owner"> {{ request.owner }}</td>
        <td v-else> N/A</td>
        <td v-if="request.species"> {{ request.species }}</td>
        <td v-else> N/A</td>
        <td v-if="request.type"> {{ request.type }}</td>
        <td v-else> N/A</td>
        <td v-if="request.amount"> {{ request.amount }}</td>
        <td v-else> N/A</td>
        <td v-if="request.request_date"> {{ request.request_date }}</td>
        <td v-else> N/A</td>
        <td v-if="request.response_date"> {{ request.response_date }}</td>
        <td v-else> N/A</td>
        &nbsp;
        <b-icon
            @click="viewMyRequest(request)"
            class="border border-info rounded"
            :font-scale="`${font_scale}`" icon="eye-fill"
            title="View"
            v-b-modal.modal-sample-request
            v-b-tooltip.hover variant="info"
        ></b-icon>
        &nbsp;
        <b-icon
            @click="showModal = !showModal"
            @mouseover="fillFormForUpdate(request)"
            class="border border-info rounded"
            :font-scale="`${font_scale}`"
            icon="pencil" title="Update"
            v-b-modal.modal-sample-request-edit v-b-tooltip.hover
            v-if="request.status === 'PENDING'"
            variant="info"
        ></b-icon>
        &nbsp;
        <b-icon
            @click="deleteSampleRequest(request.code)"
            class="border rounded bg-danger p-1"
            :font-scale="`${font_scale}`" icon="trash"
            title="Delete" v-b-tooltip.hover
            variant="light"
        ></b-icon>
      </tr>
      </tbody>
    </table>
    </details>

    <!-- SAMPLE REQUEST MODALS -->
    <b-modal
        id="modal-sample-request"
        title="About Sample Request"
        v-model="showModalView"
    >
      <p><em>Project:</em> {{ request.project }}</p>
      <p><em>Owner:</em> {{ request.owner }}</p>
      <p><em>Sample Type:</em> {{ request.type }}</p>
      <p><em>Sample Species:</em> {{ request.species }}</p>
      <p><em>Requested Amount:</em> {{ request.amount }}</p>
      <p><em>Request Date:</em> {{ request.request_date }}</p>
      <p><em>Response Date:</em> {{ request.response_date }}</p>
      <p><em>Request Status:</em> {{ request.status }}</p>
      <p><em>Notes:</em> <br> {{ request.notes }}</p>

      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button @click="cancel()" size="md" variant="danger">
          Cancel
        </b-button>
        <div v-if="request.status === 'PENDING'">
          <b-button @click="fillFormForUpdate(request); showModal = !showModal" size="md" variant="primary">
            Update
          </b-button>

          <b-button @click="sendReminder = true; updateSample(request.code)"
                    class="btn btn-outline-dark" size="md"> Send Reminder
          </b-button>
        </div>

        <div v-else>
          <b-button disabled size="md" variant="primary"> Update</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
        @ok="updateSample(sampleRequest.code)"
        cancel-variant="danger"
        id="modal-sample-request"
        ok-title="Update"
        title="Update Sample Request"
        v-model="showModal"
    >
      <form>
        <b-form-group id="form-amount-group" label="Amount:" label-for="form-amount-input">
          <b-form-input
              id="form-amount-input"
              min=1
              placeholder="Enter Amount"
              required
              type="number"
              v-model="sampleRequest.amount"
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </details>
</div>
</template>

<script>
import {
  getUserDashboardInfo,
  handleError,
  secureStoreGetAuthString,
  showFlashMessage,
  startLoader
} from "@/utils/util_functions";
import axios from "axios";
import {sample_request_resource} from "@/utils/api_paths";
import EventBus from "@/components/EventBus";
import {font_scale} from "@/utils/constants";

export default {
name: "UserSampleRequests",
  data() {
    return{
      font_scale,
      response: {},
      request: {},
      showModal: false,
      showModalView: false,
      sampleRequest: {amount: null},
    }
  },

  mounted() {
    EventBus.$on('created-user-dashboard', ()=> {
      this.response = getUserDashboardInfo()
    })
  },

  methods: {
    viewMyRequest(requestData) {
      this.request = requestData
      this.showModalView = !this.showModalView
    },

    fillFormForUpdate(request) {
      this.sampleRequest = request;
    },

    deleteSampleRequest(code) {
      let loader = startLoader(this)

      axios.delete(sample_request_resource, {
        headers: {
          Authorization: secureStoreGetAuthString(),
          code: code
        }
      }).then((response) => {
            setTimeout(() => {
              loader.hide()
              showFlashMessage(this, 'success', response.data.message, '')
            }, this.time)
          })
          .catch((error) => { handleError(this, error, loader)});
      this.getUserDetails()
    },

    updateSample(code) {
      let header = '';
      this.showModal = false
      this.showModalView = false
      let loader = startLoader(this)

      // set headers depending on what the user is trying to do
      header = this.sendReminder ? 'resend' : 'update'
      this.sendReminder = false;

      axios.put(sample_request_resource, {
        sample: code,
        amount: this.sampleRequest.amount
      }, {
        headers: {
          Authorization: secureStoreGetAuthString(),
          code: code,
          resend: header,
        }
      })
          .then((response) => {
            setTimeout(() => {
              loader.hide()
              showFlashMessage(this, 'success', response.data.message, '')
            }, 2500)
          })
          .catch((error) => { handleError(this, error, loader) });
    },
  }
}
</script>